import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { hasPermission } from '@/lib/permissions'
import { HomePage } from '@/pages/HomePage'
import { ForbiddenPage } from '@/pages/ForbiddenPage'
import type { Permission } from '@/api/types'

// Samma prioritetsordning som huvudmenyn. Saknar användaren reports.read landar den
// på första sidan den faktiskt har tillgång till, istället för ett nekat-meddelande.
const FALLBACK_ROUTES: { path: string; permissions: Permission[] }[] = [
  { path: '/customers', permissions: ['customers.read'] },
  { path: '/deliveries', permissions: ['shipments.read'] },
  { path: '/invoices', permissions: ['invoicing.read'] },
  { path: '/users', permissions: ['accounts.manage'] }
]

export function HomeRoute(): React.ReactElement {
  const user = useAuthStore((state) => state.user)

  if (hasPermission(user, 'reports.read')) return <HomePage />

  const fallback = FALLBACK_ROUTES.find((route) => hasPermission(user, ...route.permissions))

  if (fallback)
    return (
      <Navigate
        to={fallback.path}
        replace
      />
    )

  return <ForbiddenPage />
}
